import React, { useState, useEffect } from "react";
import { Col, Button, Form, Row } from "react-bootstrap";
import { Formik } from "formik";
import Image from "../../../utilities/imageTestApi/image";
import MultipleSelect from "../../multiSelect";
import RoomCategoryList from "./roomCategoryList";
import { GetVendor } from "../../../entities/action/action";
import SingleSelect from "../../../utilities/singleSelect/singleSelect";

const RoomName = (props) => {
  const [select, updateSelect] = useState([]);
  const [file1, updateFile1] = useState({});
  const [file2, updateFile2] = useState({});
  const [file3, updateFile3] = useState({});
  const [dataSet, updateDataSet] = useState([]);
  const [amenities, updateAmenities] = useState([]);
  const [vendorList, updateVendorList] = useState([]);
  const [accList, updateAccList] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await GetVendor();
      if (res != undefined && res.length > 0) {
        const arr = res.filter(
          (item, key) =>
            item.companyInformation.vendortype === "Accommodation Provider"
        );
        console.log(res);
        updateVendorList(arr);
      }
    })();
  }, []);
  const [accomodationId, updateaccomodationId] = useState("");

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem('token');
      const authHeader = `Bearer ${token}`
      const res = await fetch("https://api.zupptravel.com/api/v1/hotel/getAmenities", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          'Authorization': authHeader
        }
      });
      const json = await res.json();
      if (json.success) {
        updateAmenities(json.amenities);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem('token');
      const authHeader = `Bearer ${token}`
      const myresponse = await fetch(
        `https://api.zupptravel.com/api/v1/accommodation/getAccommodation`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
            'Authorization': authHeader
          },
        }
      );
      const json = await myresponse.json();

      if (json.success) {
        updateDataSet(json.accommodations);
      }
    })();
  }, []);
  const [vendorId, updateVendorId] = useState("");

  const arr = [];
  useEffect(() => {
    dataSet.map((data, key) => {
      if (data.vendorId == vendorId) {
        arr.push(data);
      }
    });

    updateAccList(arr);
  }, [vendorId]);

  console.log(select);
  return (
    <div style={{ padding: "20px" }}>
      <Formik
        initialValues={{ title: "" }}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
          const img1 = await Image(file1);
          const img2 = await Image(file2);
          const img3 = await Image(file3);
          const images = [];
          if(img1){
            images.push(img1);
          }
          if(img2){
            images.push(img2);
          }
          if(img3){
            images.push(img3);
          }
          const a1 = [];

          select.map((value) => {
            a1.push(value);
          });


          const data1 = {
            accId: accomodationId,
            accommodationId: accomodationId,
            amenities: a1,
            vendorId: vendorId,
            images: images?.join(','),
            name: values.roomName,
            noOfRooms: values.noOfRooms,
            id: 0,
          };
          console.log("dataaaa1", data1);

        const token = localStorage.getItem('token');
        const authHeader = `Bearer ${token}`
        const response = await fetch(
            "https://api.zupptravel.com/api/v1/roomCategory/addRoomCategory",
            {
              method: "post",
              headers: {
                "Content-Type": "application/json",
                'Authorization': authHeader
              },
              body: JSON.stringify(data1),
            }
          );

          console.log("dataaaa1", data1);

          const json = await response.json();
          console.log("sonnnnnnnnn", json);
          if (json.success) {
            alert("Added Room Category");
            // setTimeout(() => {
            //   window.location.reload();
            // }, 0);
            // props.click();
          

          } else {
            alert("Error! Please try again later");
          }
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form>
            <Form.Group controlId="formBasicVendor" as={Row}>
              <Form.Label column sm="2">
                Vendor ID:
              </Form.Label>
              <Col sm="10">
                <SingleSelect
                  type="3"
                  list={vendorList}
                  change={(select) => updateVendorId(select)}
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicVendor" as={Row}>
              <Form.Label column sm="2">
                Accommodation ID:
              </Form.Label>
              <Col sm="10">
                <SingleSelect
                  type="4"
                  list={accList}
                  change={(select) => updateaccomodationId(select)}
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicRoomName" as={Row}>
              <Form.Label column sm="2">
                Room Name:
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  type="text"
                  placeholder="Enter Room Name"
                  name="roomName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.roomName}
                  required
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicMetaNoOfRooms" as={Row}>
              <Form.Label column sm="2">
                No. of Rooms:
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  type="number"
                  placeholder="Enter No. of Rooms"
                  name="noOfRooms"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.noOfRooms}
                  required
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicAmenities" as={Row}>
              <Form.Label column sm="2">
                Select Amenities:
              </Form.Label>
              <Col sm="10">
                <MultipleSelect
                  amenities={amenities}
                  type="10"
                  selectedValue={(selected) => updateSelect(selected)}
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicPromo" as={Row}>
              <Form.Label column sm="2">
                Image:
              </Form.Label>
              <Col sm="3">
                <Form.Control
                  type="file"
                  name="file1"
                  onChange={(e) => updateFile1(e.target.files[0])}
                  required
                />
              </Col>
              <Col sm="3">
                <Form.Control
                  type="file"
                  name="file2"
                  onChange={(e) => updateFile2(e.target.files[0])}
                  required
                />
              </Col>
              <Col sm="3">
                <Form.Control
                  type="file"
                  name="file3"
                  onChange={(e) => updateFile3(e.target.files[0])}
                  required
                />
              </Col>
            </Form.Group>
            <center>
              <Button disabled={isSubmitting} onClick={handleSubmit} variant="success">
                Save Room Category
              </Button>
            </center>
          </Form>
        )}
      </Formik>
      <hr />
      {/* <RoomCategoryList /> */}
    </div>
  );
};
export default RoomName;
